<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Quản lý ảnh của sản phẩm</strong>
          </div>
          <b-grid
            :gridOptions="gridImageOptions"
            selectable
            :items="items"
            gridName="Danh sách hình ảnh sản phẩm"
            ref="productImagesTable"
          >
            <template v-slot:actions>
              <b-button
                size="md"
                variant="primary"
                v-b-modal.modalPopover
                title="Thêm mới"
              >
                Thêm mới
              </b-button>
              <b-button
                size="md"
                @click.stop="deletes"
                variant="danger"
                :disabled="isDisabledDelete"
              >
                Xóa
              </b-button>
            </template>
            <template v-slot:cell(preview)="row">
              <b-img
                :src="getUrlImage(row.item.urlImage)"
                :alt="row.item.title"
                class="wh200"
              ></b-img>
            </template>
            <template v-slot:cell(urlImage)="row">
              {{ row.item.urlImage }}
            </template>
            <template v-slot:cell(title)="row">
              <b-form-input type="text" v-model="row.item.title">
              </b-form-input>
            </template>
            <template v-slot:cell(type)="row">
              <select2
                class="no-padding col-10"
                v-model="row.item.type"
                v-if="typeImages.length > 0"
                :options="typeImages"
                allowClear="true"
                placeholder="--- Chọn ---"
              ></select2>
            </template>
            <template v-slot:cell(orderDisplay)="row">
              <b-form-input type="number" v-model="row.item.orderDisplay">
              </b-form-input>
            </template>
            <template v-slot:cell(_actions)="row">
              <b-button-group>
                <template>
                  <b-button
                    v-if="authorize(['ManageProduct'])"
                    size="sm"
                    @click.stop="remove(row.item, row.index, $event.target)"
                    class="mr-1"
                    title="xóa"
                    variant="danger"
                  >
                    Xoá
                  </b-button>
                </template>
              </b-button-group>
            </template>
          </b-grid>
          <div class="text-center">
            <b-button variant="primary" @click.stop="save"> Lưu </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      id="modalPopover"
      size="xl"
      title="Tải lên hình ảnh"
      static
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
      no-close-on-backdrop
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-row>
          <b-col>
            <b-form-group
              label="Đường dẫn hình ảnh:"
              label-for="urlImage"
              :label-cols="2"
              :horizontal="true"
              label-align="right"
              label-class="required"
            >
              <b-form-file
                v-model="$v.files.$model"
                @change="onFileChange"
                class="col-10 no-padding"
                accept="image/*"
                browse-text="Chọn"
                multiple
                placeholder="Chọn một tệp hoặc thả nó vào đây ..."
                :state="$v.files.$dirty ? !$v.files.$error : false"
                ref="file-inputs"
              >
                <template slot="file-name" slot-scope="{ names }">
                  <b-badge variant="dark">{{ names[0] }}</b-badge>
                  <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
                    + {{ names.length - 1 }} tệp khác
                  </b-badge>
                </template>
              </b-form-file>

              <b-form-invalid-feedback>
                Vui lòng chọn tệp tải lên !
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              label=""
              label-for="urlImage"
              :label-cols="2"
              :horizontal="true"
              label-align="right"
            >
              <b-row v-for="item in fileUploaded" :key="item.fileName">
                <b-col :md="12">
                  <label class="col-form-label mr-2">
                    {{ item.urlImage }}
                    <!-- || {{ item.urlResize }} -->
                  </label>
                  <!-- <b-button size="sm" variant="primary" @click.stop="changeSize(item)"
                                        v-b-modal.modalPopover2 title="Sửa kích thước">Sửa</b-button> -->
                  <b-button
                    size="sm"
                    variant="danger"
                    @click.stop="revertUpload(item)"
                    >Xóa</b-button
                  >
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-row>
                    <b-col>
                        <b-form-group label="" label-for="checkbox-group-1" :label-cols="2" :horizontal="true"
                            label-align="right">
                            <b-form-checkbox v-model="isResize">
                                Thay đổi kích thước mới
                            </b-form-checkbox>
                        </b-form-group>

                    </b-col>
                </b-row>
                <b-row v-if="isResize">
                    <b-col>
                        <b-form-group label="Chiều rộng:" label-for="width" :label-cols="2" :horizontal="true"
                            label-align="right" label-class="required">
                            <b-form-input type="text" id="width" class="col-10" aria-describedby="widthFeedback"
                                v-model="$v.width.$model" :state="$v.width.$dirty ? !$v.width.$error : null">
                            </b-form-input>
                            <b-form-invalid-feedback id="widthFeedback">
                                Vui lòng nhập chiều rộng
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row v-if="isResize">
                    <b-col>
                        <b-form-group label="Chiều cao:" label-for="height" :label-cols="2" :horizontal="true"
                            label-align="right" label-class="required">
                            <b-form-input type="text" id="height" class="col-10" aria-describedby="heightFeedback"
                                v-model="$v.height.$model" :state="$v.height.$dirty ? !$v.height.$error : null">
                            </b-form-input>
                            <b-form-invalid-feedback id="heightFeedback">
                                Vui lòng nhập chiều dài
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row> -->
        <b-row>
          <b-col>
            <b-form-group
              label=""
              label-for="urlImage"
              :label-cols="2"
              :horizontal="true"
              label-align="right"
            >
              <b-button
                :disabled="!files.length > 0"
                variant="primary"
                @click.stop="uploadImageReturnUrl"
                >Upload và lấy url</b-button
              >
            </b-form-group>
          </b-col>
        </b-row>
      </form>
      <template #modal-footer="{ ok, cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="primary" @click="ok()">
          Thêm đường dẫn vào danh sách
        </b-button>
        <b-button size="sm" variant="secondary" @click="cancel()">
          Hủy
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modalPopover2"
      size="xl"
      title="Tải lên hình ảnh"
      static
      @show="resetModal2"
      @hidden="resetModal2"
      @ok="handleOk2"
      no-close-on-backdrop
      scrollable
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <Sliders :options="sliders">
          <template #content-custom>
            <b-button variant="primary"> Lưu slot </b-button>
          </template>
        </Sliders>
        <b-row>
          <b-col>
            <b-form-group
              label="Kích cỡ ảnh"
              label-for="urlImage"
              :label-cols="2"
              :horizontal="true"
              label-align="right"
            >
              <select2
                class="no-padding col-10"
                v-model="defaultSizeSelected"
                v-if="defaultSize.length > 0"
                :options="defaultSize"
                placeholder="--- Chọn ---"
              >
              </select2>
            </b-form-group>
          </b-col>
        </b-row>
        <cropper
          classname="cropper"
          ref="cropper"
          :src="img"
          @change="change"
          :default-size="sizeImageDefault"
        />
      </form>
      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="primary" @click="ok()"> Crop </b-button>
        <b-button size="sm" variant="secondary" @click="cancel()">
          Hủy
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { authorizationMixin } from "@/shared/mixins";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  name: "ProductImages",
  mixins: [authorizationMixin],
  data() {
    return {
      searchForm: {
        str: null,
      },
      isDisabledDelete: true,
      gridImageOptions: {
        fields: [
          {
            key: "preview",
            label: "Xem trước",
            sortable: true,
            thAttr: { width: 250 },
          },
          {
            key: "urlImage",
            label: "Đường dẫn",
            sortable: true,
            thAttr: { width: 250 },
          },
          {
            key: "title",
            label: "Tiêu đề",
            sortable: true,
            sortDirection: "asc",
          },
          {
            key: "type",
            label: "Kiểu ảnh",
            sortable: true,
            thAttr: { width: 250 },
          },
          {
            key: "orderDisplay",
            label: "Thứ tự hiển thị",
            sortable: true,
            thAttr: { width: 100 },
          },
        ],
        sortBy: "orderDisplay",
      },
      files: [],
      fileUploaded: [],
      filePaths: [],
      items: [],
      isResize: false,
      width: null,
      height: null,
      top: null,
      left: null,
      img: "https://images.pexels.com/photos/226746/pexels-photo-226746.jpeg",
      defaultSize: [],
      defaultSizeSelected: null,
      sliders: [],
      typeImages: [
        { id: 1, text: "Mặc định" },
        { id: 2, text: "360" },
        { id: 3, text: "Mặt cắt" }
    ],
    };
  },
  computed: {
    productId() {
      return this.$route.params.productId;
    },
  },
  watch: {
    defaultSizeSelected() {
      this.resize();
    },
    isResize(val) {
      if (val) {
        const file = this.files;
        console.log(URL.createObjectURL(file[0]).toString());
        this.img = URL.createObjectURL(file[0]);
        // for (let i = 0; i <= file.length; i++) {
        //     this.sliders.push(
        //         {
        //             title: 'El Teide Volcano, Spain' + i,
        //             content: 'Photo by Max Rive' + i,
        //             // You can also provide a URL for the image.
        //             image: URL.createObjectURL(file[i]).toString(),
        //             link: '#'
        //         }
        //     );
        // }
        this.$bvModal.show("modalPopover2");
      }
    },
  },
  created() {
    this.loadImageByProductId();
    this.loadAllSizeImageProduct();
  },
  validations: {
    files: { required },
    width: {
      required: requiredIf(function () {
        return this.isResize;
      }),
    },
    height: {
      required: requiredIf(function () {
        return this.isResize;
      }),
    },
  },
  mounted() {
    this.$watch(
      () => {
        return this.$refs.productImagesTable.selectedRows;
      },
      (val) => {
        this.isDisabledDelete = val.length == 0;
      }
    );
  },
  methods: {
    sizeImageDefault() {
      let size = this.defaultSize.find(
        (x) => x.text == this.defaultSizeSelected
      );
      return size;
    },
    resize() {
      let size = this.defaultSize.find(
        (x) => x.text == this.defaultSizeSelected
      );
      this.$refs.cropper.setCoordinates({
        width: size.width,
        height: size.height,
      });
    },
    loadAllSizeImageProduct() {
      var vm = this;
      return this.$services
        .get(`lookup/all-size-images/product`)
        .done((size) => {
          vm.defaultSize =
            size.map((x) => {
              return {
                text: x.name,
                value: x.name,
                id: x.name,
                width: x.width,
                height: x.height,
              };
            }) || [];

          vm.defaultSizeSelected = vm.defaultSize[0].id;
        });
    },
    loadImageByProductId() {
      var vm = this;
      return this.$services
        .get(`master-data/products/${this.productId}/images`)
        .done((product) => {
          // vm.items = product.urlImages || [];
          vm.items =
            product?.map((x) => {
              return {
                urlImage: x.urlImage,
                title: x.title,
                alt: x.alt,
                orderDisplay: x.orderDisplay,
                type: x.type,
              };
            }) || [];
        });
    },
    remove(item) {
      if (confirm("Bạn có chắc chắn muốn xóa ảnh sản phẩm này?")) {
        this.items.remove(item);
      }
    },
    deletes() {
      var vm = this;
      var selectedRows = this.$refs.productImagesTable.selectedRows;
      if (selectedRows.length > 0) {
        if (confirm("Bạn có chắc chắn muốn xóa các sản phẩm này?")) {
          let data = selectedRows.map((x) => x) || [];
          data.forEach((item) => {
            let indexI = vm.items.indexOf(item);
            if (indexI > -1) {
              vm.items.splice(indexI, 1);
            }
          });
        }
      } else {
        vm.$toastr.e("Vui lòng chọn sản phẩm cần xóa");
      }
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      var vm = this;
      this.fileUploaded.forEach((item, index) => {
        const itemTemp = {
          ...item,
          title: null,
          alt: null,
          orderDisplay: ++index,
          type: 1,
        };
        vm.items.push(itemTemp);
      });
      this.$nextTick(() => {
        this.$bvModal.hide("modalPopover");
      });
    },
    resetModal() {
      this.files.length = 0;
      this.fileUploaded.length = 0;
      this.filePaths.length = 0;
      this.$refs["file-inputs"].reset();
      this.$v.$reset();
    },
    uploadImageReturnUrl() {
      var vm = this;
      vm.$v.$touch();
      if (!vm.$v.$invalid) {
        if (vm.files) {
          let formData = new FormData();
          vm.files.forEach((item) => {
            formData.append("files", item);
          });

          formData.append("width", vm.width || "");
          formData.append("height", vm.height || "");

          vm.$services
            .post("master-data/uploads", null, {
              enctype: "multipart/form-data",
              data: formData,
              processData: false,
              contentType: false,
            })
            .done((data) => {
              vm.fileUploaded = data.filter((x) => x.status == 1);
              if (data) {
                vm.$toastr.s(`Tải lên ${vm.fileUploaded.length} thành công!`);
              } else {
                vm.$toastr.e("Đã xảy ra lỗi, vui lòng thử lại!");
              }
            });
        } else {
          vm.$toastr.e("Vui lòng chọn file để tải lên!");
        }
      }
    },
    revertUpload(item) {
      if (item && item.urlImage) {
        this.$services
          .post(`master-data/undo?path=${item.urlImage}`)
          .done(() => {
            this.fileUploaded.remove(item);
            this.$toastr.s("Hoàn tác thành công");
          });
      }
    },
    save() {
      var vm = this;
      const imgs = this.items;
      this.$services
        .put(`master-data/products/${this.productId}/images`, imgs)
        .done(() => {
          vm.$toastr.s("Cập nhật ảnh sản phẩm thành công");
          vm.$refs.productImagesTable.refresh();
        });
    },
    getUrlImage(path) {
      return this.$services.getResourceUrl() + path;
    },
    change({ coordinates }) {
      this.height = coordinates.height;
      this.left = coordinates.left;
      this.top = coordinates.top;
      this.width = coordinates.width;
    },
    changeSize(item) {
      this.img = this.getUrlImage(item.urlImage);
    },
    handleOk2(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.handleSubmit2();
    },
    handleSubmit2() {
      this.uploadAndCrop();
      this.$nextTick(() => {
        this.$bvModal.hide("modalPopover2");
      });
    },
    resetModal2() {
      this.$v.$reset();
    },
    onFileChange() {
      //const file = e.target.files[0];
      //this.img = URL.createObjectURL(file);
      //this.$bvModal.show('modalPopover2');
    },
    uploadAndCrop() {
      var vm = this;
      vm.$v.$touch();
      if (!vm.$v.$invalid) {
        if (vm.files) {
          let formData = new FormData();
          vm.files.forEach((item) => {
            formData.append("files", item);
          });

          formData.append("width", vm.width || "");
          formData.append("height", vm.height || "");
          formData.append("top", vm.top || "");
          formData.append("left", vm.left || "");

          vm.$services
            .post("master-data/uploads-crop", null, {
              enctype: "multipart/form-data",
              data: formData,
              processData: false,
              contentType: false,
            })
            .done((data) => {
              console.log(data);
              vm.fileUploaded = data.filter((x) => x.status == 1);
              if (data && vm.fileUploaded.length > 0) {
                vm.$toastr.s(`Tải lên ${vm.fileUploaded.length} thành công!`);
                vm.$bvModal.show("modalPopover2");
                vm.img = vm.getUrlImage(data[0].urlResize);
                //vm.img = URL.createObjectURL(data[0]);
              } else {
                vm.$toastr.e("Đã xảy ra lỗi, vui lòng thử lại!");
              }
            });
        } else {
          vm.$toastr.e("Vui lòng chọn file để tải lên!");
        }
      }
    },
  },
};
</script>
<style scoped>
.cropper {
  height: 600px;
  background: #ddd;
}

.wh200 {
  width: 200px;
  height: 200px;
}
</style>
